import React from "react";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";

const OtpInputBox = ({ value, onChange, onKeyDown, inputRef, onPaste }) => {
  return (
    <TextField
      inputProps={{
        style: { color: "#475467" },
        maxLength: 1,
      }}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      inputRef={inputRef}
      onPaste={onPaste}
      variant="outlined"
      size="small"
      type="text"
      sx={{
        width: { xs: 40, sm: 56 },
        "& .MuiInputBase-input": {
          textAlign: "center",
          fontWeight: "bold",
          fontSize: { xs: "20px", sm: "28px" },
          height: { xs: 24, sm: 34 },
          padding: { xs: "8px 0", sm: "8px 4px" },
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderWidth: "2px",
            borderColor: "#D0D5DD",
            borderRadius: "10px",
          },
          "&:hover fieldset": {
            borderColor: "#a9a9a9", // Slightly darker on hover
            borderRadius: "10px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#808080", // Darker when focused
            borderRadius: "10px",
          },
        },
      }}
    />
  );
};

OtpInputBox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  onPaste: PropTypes.func,
};

export default OtpInputBox;
